import { render, staticRenderFns } from "./AddCandidate.vue?vue&type=template&id=42c8cd10&"
import script from "./AddCandidate.vue?vue&type=script&lang=js&"
export * from "./AddCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports